import * as React from "react";
import { IconProps } from "./IconProps";

export const IconBell = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.51316 7.57045C3.94666 4.31922 6.72001 1.89111 10 1.89111C13.28 1.89111 16.0533 4.31923 16.4868 7.57045L17.4927 15.1143C17.5244 15.3524 17.4519 15.5926 17.2937 15.7734C17.1354 15.9541 16.9069 16.0578 16.6667 16.0578H13.872C13.1185 17.5144 11.6989 18.5578 10 18.5578C8.30114 18.5578 6.88148 17.5144 6.12803 16.0578H3.33334C3.09312 16.0578 2.86459 15.9541 2.70635 15.7734C2.54811 15.5926 2.47557 15.3524 2.50732 15.1143L3.51316 7.57045ZM8.14852 16.0578C8.65597 16.5888 9.31397 16.8911 10 16.8911C10.686 16.8911 11.344 16.5888 11.8515 16.0578H8.14852ZM10 3.55778C7.55535 3.55778 5.48831 5.36751 5.16521 7.79072L4.28516 14.3911H15.7149L14.8348 7.79072C14.5117 5.36751 12.4447 3.55778 10 3.55778Z"
          fill={color}
        />
      </svg>
    );
  },
);
